import React from "react";
import Truncate from "src/components/truncate";
import cx from "classnames";
import { Row, Col, Image } from "react-bootstrap";
import dateformat from "dateformat";

import ContactDetailsSlideView from "src/legacy/components/Contacts/ContactDetails/ContactDetailsSlideview";
import { localizedStrings } from 'src/localization';

import styles from "./ContactListItemRow.module.scss";
import Tooltip from "src/components/tooltip";
import _ from "lodash";

class ContactListItemRow extends React.Component {
  constructor(props) {
    super(props);

    this._handleDeleteClick = this._handleDeleteClick.bind(this);
    this._handleContactItemClick = this._handleContactItemClick.bind(this);

    this.state = {
      showContactSlideView: false,
      selectedContact: null,
    };

    this.localizedCommons = localizedStrings.commons;
  }

  renderName() {
    return `${this.props.contact.firstName || ""} ${
      this.props.contact.lastName || ""
    }`;
  }

  renderInitials() {
    let initial = "";

    if (this.props.contact.firstName) {
      initial = this.props.contact.firstName.charAt(0);
    }

    if (this.props.contact.lastName) {
      initial = initial + this.props.contact.lastName.charAt(0);
    }

    return initial.toUpperCase();
  }

  _handleContactItemClick(contact) {
    this.setState({
      showContactSlideView: true,
      selectedContact: contact,
    });
  }

  _handleDeleteClick() {
    this.props.onRemove(this.props.contact);
  }

  render() {
    if (!this.props.contact) {
      return null;
    }

    return (
      <>

      <Row className={cx(styles.recipient, this.props.className)}>
        <Col md={9} className={styles.noPadding}>
          <div
            onClick={() => this._handleContactItemClick(this.props.contact)}
            className={styles.recipientLink}
          >
            <div className={styles.recipientRow}>
              <div className={styles.left}>
                <div className={styles.iconContainer}>
                  {!_.get(this.props,"contact.icon") && <div className={styles.contactAvatar}>
                    <i className="paperflite-user-settings" />
                  </div>}
                  {this.props.contact.icon && this.props.contact.icon.full && (
                    <Image
                      className={styles.contactIcon}
                      src={_.get(this.props,"contact.icon.thumbnail")}
                      circle
                    />
                  )}
                </div>
              </div>
              <div className={styles.body}>
                <Tooltip content={this.renderName().length > 40 ? this.renderName() : ""}>
                <div className={styles.contactName}>
                  <Truncate width={300}> {this.renderName()} </Truncate>
                </div>
                </Tooltip>
                 <Tooltip content={this.props.contact.email.length > 40 ? this.props.contact.email : ""}> 
                <div className={styles.contactTitle}>
                  <Truncate width={200}>
                    {this.props.contact.email || this.localizedCommons.no_details}
                  </Truncate>
                </div>
                </Tooltip>
              </div>
            </div>
          </div>
        </Col>
        <Col md={3} className={cx(styles.column,styles.rightAlign)}>
          <div className={styles.lastVisited}>
            <span className={styles.label}>{this.localizedCommons.last_active}</span>
            <span className={styles.label}>
              {dateformat(this.props.contact.createdDate, "dd mmm yyyy")}
            </span>
          </div>
          {this.props.editing && (
            <Col
              className={cx(styles.column, styles.deleteButton, {
                [styles.active]: this.props.editing,
              })}
            >
              <span
                className="paperflite-close"
                onClick={this._handleDeleteClick}
              ></span>
            </Col>
          )}
        </Col>
        {this.state.showContactSlideView && (
          <ContactDetailsSlideView
            contactList={this.props.contactList ? this.props.contactList : ""}
            onClose={() => this.setState({ selectedContact: null })}
            selectedContact={this.state.selectedContact}
            canDelete={true}
          />
        )}
      </Row>

      </>
    );
  }
}

ContactListItemRow.defaiultProps = {};

export default ContactListItemRow;
